import React from 'react'
import i18next from 'i18next'

import { PostalCodeForm } from 'app/delivery-area/components/postal-code-form'

import iOSImage from './assets/app-store-badge.svg'
import AndroidImage from './assets/google-play-badge.svg'

import './DownloadApp.css'

const iOSLink = 'https://itunes.apple.com/app/apple-store/id1368037685'
const AndroidLink =
  'https://play.google.com/store/apps/details?id=es.mercadona.tienda'

const DownloadApp = () => (
  <section
    className="download-app"
    role="complementary"
    aria-labelledby="download-app-title"
  >
    <h2 className="download-app__title" id="download-app-title">
      {i18next.t('header_section.title')}
    </h2>
    <PostalCodeForm />
    <p className="download-app__message">{i18next.t('download_app_message')}</p>
    <a href={AndroidLink} target="_blank" rel="noopener noreferrer">
      <img className="download-app__android" src={AndroidImage} alt="Android" />
    </a>
    <a href={iOSLink} target="_blank" rel="noopener noreferrer">
      <img className="download-app__ios" src={iOSImage} alt="iOS" />
    </a>
  </section>
)

export { DownloadApp }
